// Ads › Online Ads — ฝัง Campaign Report ของ Biddable
//
// iframe ตรงข้ามโดเมน (ไม่ผ่าน reverse proxy) เหมือน KOL เพราะ prefix /api บนโดเมนเรา
// ยกให้ Inbox Center ไปแล้ว · ต่างกันตรงที่ Biddable ไม่มีโหมด public → ส่ง session
// ของผู้ใช้ไปทาง `#token=` (fragment ไม่ใช่ query เพื่อไม่ให้ token โผล่ใน log ของเขา)
//
// เดิมฝังหน้า Creative Report (?view=creative) แล้ว scope ด้วย ad account + ชื่อแคมเปญ
// เขาลบหน้านั้นทิ้งแล้ว หน้าใหม่คือ Campaign Report ซึ่งจัดกลุ่มเป็น "project"
// (รหัสงานในชื่อแคมเปญ เช่น P2026-124) และรวมทุก platform ของงานนั้นไว้ด้วยกัน
import { wazzupToken } from "@features/inbox/api/inbox-api";

export const BIDDABLE_BASE = "https://biddablenew-production.up.railway.app";

/** สิ่งที่ผูกไว้กับแคมเปญของเรา — เก็บใน meta ของลิงก์ kind "ads_project" */
export type AdsScope = { project?: string; platforms?: string[] };

/**
 * embed = true  → ในกรอบ (ซ่อน topnav ของเขา + ส่ง session ไปให้)
 * embed = false → ลิงก์ "เปิดในแท็บใหม่" เปิดแอปเต็มของเขาแต่โฟกัส project เดียวกัน
 */
export function biddableUrl(meta: AdsScope | null, { embed = true } = {}): string {
  const q = new URLSearchParams({ view: "campaign" });
  if (embed) q.set("embed", "1");
  // ระบุ project = กรองให้เหลืองานเดียวและกางให้เลย · ไม่ระบุ = เห็นทุกงานเหมือนเปิดตรง ๆ
  if (meta?.project) q.set("project", meta.project);
  const token = embed ? wazzupToken() : null;
  return `${BIDDABLE_BASE}/?${q}` + (token ? `#token=${encodeURIComponent(token)}` : "");
}
